module.exports = __webpack_public_path__ + "feb7904.woff";